import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowTopRightCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareArrowTopRightCorner"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M11.5 6.5H17.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17 7L11 13" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareArrowTopRightCorner;
